module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp1_5010.fc2755be.png";